import { useNavigate, useParams } from "react-router-dom";
import FormCard from "../../../../../Lib/FormCard";
import BillDetailPage from "./Components/BillDetails";
import RoomDetailsWithCheckOut from "./Components/CheckOutRoomDetails";
import CustomerDetails from "./Components/CustomerDetails";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PATCH_ROOM_BOOKING_REQUEST } from "../../../../../Utils/Constant";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";

const CheckOutBookingDetails = () => {
  const baseUrl = getBaseUrl();
  const role = localStorage.getItem("role");

  const dispatch = useDispatch();
  const { reservation_id } = useParams();
  const [reservationData, setReservationData] = useState(null);
  const navigate = useNavigate();
  const { roomReservationById } = useSelector(
    (state) => state.roomReservationList
  );
  const [summaryData, setSummaryData] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (reservation_id) {
      // dispatch({
      //     type: GET_BYID_ROOM_BOOKING_REQUEST,
      //     payload: { reservation_id },
      // });
      const getCheckoutData = async () => {
        if (!reservation_id) return;
        let token = localStorage.getItem("token");

        let response = await fetch(
          `${baseUrl}/billing/folio/reservation/${reservation_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch summary");
        }

        const result = await response.json();
        let isRemainingPayment = true;

        // Constants
        const GST_RATES = result?.data?.GST; // for services
        // const nights = 2 // based on room charge description
        // const extraBedRatePerNight = 0
        const extraBedCount = 0;

        // Initialize accumulators
        let totalRoomCharges = 0;
        let totalServiceCharges = 0;
        let totalTaxAmount = 0;
        let extraBedCharges = 0;
        let totalDiscounts = 0;
        let totalRestaurantCharges = 0;
        let totalAmountPaid = 0;

        // Rooms
        const roomsPrice = result?.data?.charges
          ?.filter((charge) => charge.charge_type === "room_charge")
          .map((charge) => {
            const pricePerNight = parseFloat(charge.unit_price);
            const nights = charge.quantity;
            const baseAmount = pricePerNight * nights;

            totalDiscounts += parseFloat(charge.discount || 0);
            totalRoomCharges += baseAmount;
            if (!charge.payment_status) {
              isRemainingPayment = false;
            }
            if(charge.payment_status){
              totalAmountPaid += (baseAmount- totalDiscounts);
            }
            return {
              room: {
                room_id: charge.room_id,
                room_number: charge.details,
                room_type: charge.item_description,
              },
              price_per_night: pricePerNight,
              total_room_price: baseAmount,
              total_amount: baseAmount,
              total_nights: nights,
              discount: charge.discount,
              payment_status: charge.payment_status,
            };
          });

        // Services
        const servicesData = result?.data?.charges
          .filter((charge) => charge.charge_type === "service_charge")
          .map((charge) => {
            const rate = parseFloat(charge.unit_price);
            const quantity = charge.quantity;
            const baseAmount = rate * quantity;

            totalServiceCharges += baseAmount;
            if (!charge.payment_status) {
              isRemainingPayment = false;
            }
            if(charge.payment_status){
              totalAmountPaid += baseAmount;
            }
            return {
              service: {
                id: charge.id,
                package_name: charge.item_description,
                description: charge.description,
              },
              price_per_night: rate,
              total_service_price: baseAmount,
              total_amount: baseAmount,
              quantity: quantity,
              discount: 0,
              payment_status: charge.payment_status,
            };
          });


        // Tax
        totalTaxAmount = parseFloat(
          parseFloat(
            ((totalRoomCharges- totalDiscounts + totalServiceCharges) * GST_RATES?.room_reservation_tax) / 100
          ).toFixed(2)
        );

        if(totalAmountPaid){
          totalAmountPaid+=totalTaxAmount
        }

        const restaurantData = result?.data?.charges
          .filter((charge) => charge.charge_type === "restaurant")
          .map((charge) => {
            const rate = parseFloat(charge.unit_price || 0);
            const quantity = charge.quantity || 0;
            const baseAmount = rate * quantity;
            const discount = parseFloat(charge.discount || 0);
            const amount = parseFloat(charge.amount || 0);
            if(charge.payment_status){
              totalAmountPaid += amount;
            }
            totalRestaurantCharges += amount;
            let tip = 0,
              gstAmount = 0,
              serviceCharge = 0,
              orderId = "-";
            try {
              const details = charge.details ? JSON.parse(charge.details) : {};
              tip = parseFloat(details.tip || 0);
              gstAmount = parseFloat(details.gst_amount || 0);
              serviceCharge = parseFloat(details.service_charge || 0);
              orderId = details.order_id || "-";
            } catch (e) {
              console.warn("Invalid JSON in details:", charge.details);
            }

            return {
              restaurant: {
                id: charge.id,
                name: `Order`,
                description: charge.description,
              },
              price_per_night: rate,
              total_restaurant_price: baseAmount,
              total_amount: amount,
              quantity,
              discount,
              tip,
              gstAmount,
              serviceCharge,
              payment_status: charge.payment_status,
            };
          });
        // // Extra bed charges
        // if (extraBedCount > 0) {
        //   extraBedCharges = extraBedRatePerNight * nights * extraBedCount
        // }

        // Subtotal and grand total
        const subtotal =
          totalRoomCharges +
          totalServiceCharges +
          extraBedCharges -
          totalDiscounts +
          totalRestaurantCharges;
        const grandTotal = subtotal + totalTaxAmount;

        // Final result
        const data = {
          roomsPrice,
          servicesData,
          restaurantData: restaurantData,
          extraBed: {
            count: extraBedCount,
            baseAmount: extraBedCharges,
            taxAmount: 0,
            totalAmount: extraBedCharges,
          },
          totalRestaurantCharges,
          totalRoomCharges,
          totalDiscounts,
          totalServiceCharges,
          totalExtraBedCharges: extraBedCharges,
          subtotal,
          totalTaxAmount,
          grandTotal,
          totalAmountPaid:totalAmountPaid,
        };
        setSummaryData(
          {
            data: data,
            details: result.data,
            payload: {
              check_in_date_time: result?.data?.reservation?.check_in_date_time,
              check_out_date_time:
                result?.data?.reservation?.check_out_date_time,
            },
          } || []
        );
      };
      getCheckoutData();
    }
  }, [reservation_id]);

  useEffect(() => {
    if (roomReservationById) {
      setReservationData(roomReservationById);
    }
  }, [roomReservationById]);

const handlePayment=()=>{
  setIsLoading(true);
  dispatch({
    type: PATCH_ROOM_BOOKING_REQUEST,
    payload: {
      reservation_id,
      body: {
        ...reservationData,
        booking_status: "check_out",
        type: "checkout",
      },
    },
  });
  setIsLoading(false)
  setTimeout(() => {
    navigate("/reservation/booking-list");
  }, 500);
}
const handleCheckout = () => {
  const remaining_payment = (
    summaryData?.data?.totalRoomCharges +
    summaryData?.data?.totalServiceCharges +
    summaryData?.data?.totalRestaurantCharges +
    summaryData?.data?.totalTaxAmount -
    summaryData?.data?.totalDiscounts -
    summaryData?.data?.totalAmountPaid
  );

  const roundedRemaining = parseFloat(remaining_payment.toFixed(2));

  if (roundedRemaining > 0) {
    setShowPaymentModal(true);
  } else {
    handlePayment();
  }
};

  return (
    <>
      <div
        className="check-out-room-contaiiner"
        style={{ padding: "6%", paddingTop: "2%" }}
      >
        <div className="d-flex justify-content-between align-items-center">
        <h1 className="add-room-booking-title" style={{ fontWeight: "10px" }}>
          Check Out
        </h1>
        <button
          type="button"
          className="btn btn-secondary"
          style={{ maxHeight: "40px" }}
          onClick={() => {
            navigate(-1);
          }}
        >
          Back
        </button>
        </div>
        <div className="row">
          {/* {summaryData && <ReviewBookingSummary summaryData={summaryData} />} */}
        </div>
        {summaryData && (
          <>
            <div>
              <FormCard>
                <CustomerDetails data={summaryData.details} />
              </FormCard>
            </div>
            <div>
              <FormCard>
                <BillDetailPage
                  data={summaryData.details}
                  payment={summaryData.data}
                />
              </FormCard>
            </div>
            <div>
              <FormCard>
                <RoomDetailsWithCheckOut
                  data={reservationData}
                  summaryData={summaryData}
                />
              </FormCard>
            </div>
            <div>
              {/* <FormCard>
                <AdditionalCharge data={reservationData} />
              </FormCard> */}
            </div>
            <div>
              {/* <FormCard>
                <SpecialDiscount data={reservationData} />
              </FormCard> */}
            </div>
          </>
        )}
     {['admin','super_admin','manager','front_desk'].includes(role) && (
        <div className="col-sm-12 text-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCheckout}
          >
            Checkout
          </button>
        </div>
    )}
      </div>


      {showPaymentModal && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <i className="bi bi-credit-card me-2"></i>
                          Complete Payment
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowPaymentModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        {/* Order Summary */}
                        <div className="card mb-4">
                          <div className="card-header">
                            <h6 className="mb-0">Order Summary</h6>
                          </div>
                          <div className="card-body">
                            <table className="table table-sm">
                              <tbody>
                                <tr>
                                  <td>Subtotal:</td>
                                  <td className="text-end">
                                    ₹{summaryData?.data?.subtotal.toFixed(2)}
                                  </td>
                                </tr>
                                <tr> 
                                  <td>Total Tax Amount:</td>
                                  <td className="text-end">
                                    ₹{summaryData?.data?.totalTaxAmount.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Total Paid Amount:</td>
                                  <td className="text-end">
                                  ₹{summaryData?.data?.totalAmountPaid.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                  Total Remaining Amount:
                                  </td>
                                  <td className="text-end">
                                  &#8377;{Math.abs(parseFloat(summaryData?.data?.totalRoomCharges + summaryData?.data?.totalServiceCharges +  summaryData?.data?.totalRestaurantCharges +  summaryData?.data?.totalTaxAmount -  summaryData?.data?.totalDiscounts -  summaryData?.data?.totalAmountPaid).toFixed(2))}
                                  </td>
                                </tr>
                                <tr className="table-active">
                                  <td className="fw-bold">Total Amount:</td>
                                  <td className="text-end fw-bold h5">
                                    ₹{summaryData?.data?.grandTotal.toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {/* Payment Method */}
                        <div className="mb-4">
                          <label className="form-label">Payment Method</label>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="cash"
                                  value="cash"
                                  checked={paymentMethod === "cash"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="cash"
                                >
                                  <i className="bi bi-cash me-2"></i>Cash
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="debit_card"
                                  value="debit_card"
                                  checked={paymentMethod === "debit_card"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="debit_card"
                                >
                                  <i className="bi bi-credit-card me-2"></i>
                                  Debit Card
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="credit_card"
                                  value="credit_card"
                                  checked={paymentMethod === "credit_card"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="credit_card"
                                >
                                  <i className="bi bi-credit-card me-2"></i>
                                  Credit Card
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="upi"
                                  value="upi"
                                  checked={paymentMethod === "upi"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="upi"
                                >
                                  <i className="bi bi-phone me-2"></i>UPI
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="bank_transfer"
                                  value="bank_transfer"
                                  checked={paymentMethod === "bank_transfer"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="bank_transfer"
                                >
                                  <i className="bi bi-globe me-2"></i>Bank
                                  Transfer
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowPaymentModal(false)}
                          disabled={isLoading}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={handlePayment}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></span>
                              Processing Payment...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-check-circle me-2"></i>
                              Complete Payment ({parseFloat(summaryData?.data?.totalRoomCharges + summaryData?.data?.totalServiceCharges + summaryData?.data?.totalRestaurantCharges + summaryData?.data?.totalTaxAmount -  summaryData?.data?.totalDiscounts -  summaryData?.data?.totalAmountPaid).toFixed(2)})
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

    </>
  );
};
export default CheckOutBookingDetails;
